<template>
  <div class="body-section">
    <div>
      <div class="title-section" style="display: flex">
        <h1 class="title title-ruban">CAMPAGNE : {{ campaign.name }}</h1>
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link to="/Campagnes">
                <span class="icon is-small">
                  <i class="fas fa-chevron-left" aria-hidden="true"></i>
                </span>
                <span>Accueil</span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div class="page-seperate"></div>
    </div>
    <b-sidebar
      type="is-light"
      :fullheight="true"
      :overlay="false"
      :right="true"
      mobile="fullwidth"
      v-model="isSidebarOpen"
    >
      <div class="level mb-0" style="width: 100%">
        <div class="level-right" style="width: 100%">
          <div class="level-item">
            <a class="is-info is-right" @click="isSidebarOpen = false">
              <b-icon
                icon="close"
                type="is-info"
                title="Ajouter une campagne"
                class="mb-2 mt-2"
              >
              </b-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="notification">
        <h3 class="subtitle">Profil du Répondant</h3>
        <profil-base :profil="userProfil"></profil-base>
      </div>
      <div class="notification">
        <h3 class="subtitle">Résultats du Répondant</h3>
        <result-card
          v-for="(result, index) in userResults"
          :key="index"
          :surveyResult="result"
          :userName="userProfil | userName"
          :userPosition="userProfil.position"
        >
        </result-card>
      </div>
    </b-sidebar>
    <div class="container">
      <div class="level mb-0" style="background-color: white; width: 100%">
        <!-- Left side -->
        <div class="level-right" style="width: 100%">
          <div class="level-item">
            <a class="is-info is-right" @click="isSearchable = !isSearchable">
              <b-icon
                icon="magnify"
                title="Rechercher"
                type="is-info"
                class="mr-5 mb-2 mt-2"
              >
              </b-icon>
            </a>
          </div>
        </div>
      </div>
      <b-table
        v-for="(survey, index) in campaign.surveys"
        :key="index"
        :data="survey"
        :striped="true"
      >
        <b-table-column
          field="email"
          label="Email Répondant"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.email }}
        </b-table-column>
        <b-table-column
          field="name"
          label="Nom Répondant"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.name }}
        </b-table-column>
        <b-table-column
          field="position"
          label="Poste Répondant"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.position }}
        </b-table-column>
        <b-table-column
          field="result"
          label="Résultat du questionnaire"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.result }}
        </b-table-column>
        <b-table-column v-slot="props">
          <div v-if="props.row.uid != undefined" style="display: flex">
            <a class="is-right" @click="openUserDetail(props.row)">
              <b-icon
                icon="magnify"
                title="Détails de la campagne"
                type="is-info"
                class="mr-2"
              >
              </b-icon>
            </a></div
        ></b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import ResultCard from "@/components/ResultCard.vue";
import ProfilBase from "@/components/Base/ProfilBase.vue";
import { getUserProfil, getSurveyResults } from "../services/dbService";
import CryptoJS from "crypto-js";
import AES from "crypto-js/aes";
export default {
  components: { ResultCard, ProfilBase },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // gestion de la side bare
      isSidebarOpen: false,
      isSearchable: false,
      userProfil: {},
      userResults: [],
    };
  },

  methods: {
    openUserDetail(userProps) {
      console.log(userProps);
      const uid = AES.decrypt(userProps.uid, "turlututu2").toString(
        CryptoJS.enc.Utf8
      );
      getUserProfil(uid).then((profilIn) => {
        this.userProfil = profilIn;
        getSurveyResults(uid).then((surveyResults) => {
          surveyResults.forEach(
            (surveyResult) => (surveyResult.userShouldHaveResult = true)
          );
          this.userResults = surveyResults;
          this.isSidebarOpen = true;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
